import { get } from "lodash";
import Select from "shared/components/Select";
import { useQuery } from "shared/hooks/useApi";
import graphql from "utils/api/graphql";

const ConnectorField = ({ value, onChange, labels }) => {
  const { data } = useQuery(graphql.queries.CONNECTORS);
  const options = (get(data, "connectors") || []).map((item) => ({
    value: item.key,
    label: `${item.label} · ${item.category}`,
  }));

  return (
    <Select
      showSearch
      allowClear
      label={labels.LABEL}
      placeholder={labels.PLACEHOLDER}
      options={options}
      value={value || undefined}
      onChange={(next) => onChange(next || null)}
    />
  );
};

export default ConnectorField;
